import { CONTINUE_LEAD_IN_SECONDS } from './constants'
import { parseTimecodeToSeconds } from './timecode'

/** Map transcript chunk search language enum to media URL language code. */
export function searchLanguageToMediaLanguage (languageEnum: string): string {
  return String(languageEnum || 'EN')
    .toLowerCase()
    .split('-')[0]
}

/** Playback start position in seconds (lead-in before chunk start, clamped to zero). */
export function chunkPlaybackStartSeconds (startTimecode: string | null | undefined): number {
  const rawStart = parseTimecodeToSeconds(startTimecode) ?? 0
  return Math.max(0, rawStart - CONTINUE_LEAD_IN_SECONDS)
}
